import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

import "components/Calendar/Calendar.scss";
import { DATE_FORMATS_FNS } from "components/DatePicker";
import { formatDate } from "utils/dateHelperFunctions";

import type { DatePickerProps } from "react-datepicker";

export const Calendar = ({ startDate, endDate, ...rest }: DatePickerProps) => {
  const { t } = useTranslation();

  return (
    <DatePicker
      className="CalendarInput"
      calendarClassName="CalendarDatepicker"
      todayButton={<span>{t("v8_today", "Today")}</span>}
      calendarStartDay={1}
      showPopperArrow={false}
      value={`${startDate ? formatDate(startDate, DATE_FORMATS_FNS.dateMonthYear) : ""} ${endDate ? `- ${formatDate(endDate, DATE_FORMATS_FNS.dateMonthYear)}` : ""}`}
      {...rest}
    />
  );
};
